"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketAclInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketAclInput.js.map